export const awsImageRootUrl = "https://applicationimages.s3.amazonaws.com";
export const baseWebUrl = "https://app.refereree.com";
